<template>
    <div id="baby-ticket-form">
        <div class="title">审核管理 > 亲子票务管理 > <span class="title-detail" @click="$router.go(-1)"> 亲子票务详情 </span></div>
        <el-card class="main">
            <el-form 
                v-loading="formLoading"
                :model="showForm"
                ref="ruleForm"
                status-icon
                label-width="200px"
                class="demo-ruleForm scorll-auto"
            >
                <div class="subtitle">
                    <h4>基本信息</h4>
                </div>
                <el-form-item label="景区名称：">
                    <span>{{ showForm.name }}</span>
                </el-form-item>
                <el-form-item label="店铺名称：">
                    <span>{{ showForm.shop_name }}</span>
                </el-form-item>
                <el-form-item label="景区星级：">
                    <span>{{ showForm.start }}星</span>
                </el-form-item>
                <el-form-item label="景区类型：">
                    <span>{{ showForm.scenic_spot }}</span>
                </el-form-item>
                <el-form-item label="景区介绍：">
                    <div v-html="showForm.desc"></div>
                </el-form-item>
                <el-form-item label="景区封面：">
                    <el-upload 
                        style="display: inline-block"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :file-list="showForm.image_detail"
                        list-type="picture-card"
                        :on-change="handleChange1"
                        :auto-upload="false"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove1"
                        :limit="1"
                        class="mf"
                        :disabled="true"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="轮播图：">
                    <el-upload 
                        style="display: inline-block"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :file-list="showForm.banner_detail"
                        list-type="picture-card"
                        :on-change="handleChange1"
                        :auto-upload="false"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove1"
                        :limit="8"
                        class="mf"
                        :disabled="true"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="景区地址：">
                    <span>{{ showForm.addr_s }} </span>
                    <span> {{ showForm.addr_i }}</span>
                </el-form-item>
                <el-form-item label="预约日历：">
                    <span>{{ showForm.calendar_name }}</span>
                </el-form-item>
                
                <!-- 到这里！！！！！！！！！！！！！ -->
                
                <el-form-item label="开园时间：">
                    <span>
                        {{ showForm.time_s }} - {{ showForm.time_e }}
                    </span>
                </el-form-item>
                <el-form-item label="购买须知：">
                    <div v-html="showForm.desc_buy"></div>
                </el-form-item>
                <el-form-item label="景区福利：">
                    <div v-html="showForm.desc_welfare"></div>
                </el-form-item>
                <div class="subtitle">
                    <h4>规格属性</h4>
                </div>
                <div v-for="(item, index) in showForm.sku_list" :key="index">
                    <el-form-item label="门票名称：">
                        <span>{{ item.name }}</span>
                    </el-form-item>
                    <el-form-item label="门票价格：">
                        <span>{{ item.price }}元</span>
                    </el-form-item>
                    <el-form-item label="有效期：">
                        <span>{{ item.u_times }}天</span>
                    </el-form-item>
                    <el-form-item label="使用时段：">
                        <span>{{ item.u_type == 1 ? '平日' : '节假日' }}</span>
                    </el-form-item>
                    <el-form-item label="预订须知：">
                        <div v-html="item.desc"></div>
                    </el-form-item>
                    <el-form-item label="项目包含：">
                        <div v-html="item.desc_buy"></div>
                    </el-form-item>
                    <el-divider v-if="showForm.sku_list.length-1 != index" ></el-divider>
                </div>
                <div class="subtitle">
                    <h4>销售数据</h4>
                </div>
                <el-form-item label="累计购票：">
                    <span>{{ showForm.sale.shop_num }}</span>
                </el-form-item>
                <el-form-item label="累计收益：">
                    <span>{{ showForm.sale.shop_price }}</span>
                </el-form-item>
                <el-form-item label="累计评价：">
                    <span>{{ showForm.sale.shop_comment }}</span>
                    <span style="margin-left: 12px;">
                        <el-link type="primary" @click="lookAppraise">查看全部评价</el-link>
                    </span>
                </el-form-item>
                <el-form-item label="评价得分：">
                    <span>{{ showForm.sale.shop_start }}</span>
                </el-form-item>
                <div class="subtitle">
                    <h4>交付方式</h4>
                </div>
                <el-form-item label="交付方式：">
                    <span v-if="showForm.g_type[0] == 1">APP、短信、站内信</span>
                    <span v-if="showForm.g_type[1] == 1" style="margin-left: 24px;">物流</span>
                    <span v-if="showForm.g_type[2] == 1" style="margin-left: 24px;">自提</span>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label-width="0" style="float: right;">
                    <el-button type="primary" @click="$router.go(-1)">返回</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import { getDateList, getAreaDetail, getAreaType } from '@/api/baby/ticket.js'
import { getShopStorage } from '@/utils/storage.js'

var MarkdownIt = require('markdown-it');
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
});
export default {
    data () {
        return {
            formLoading: false,
            ruleForm: {
                id: 0,          // 景区ID
                shop_id: '',     // 店铺ID
                name: '',       // 景区名称 2~200个字符
                start: 1,       // 景区星级 1~5星，对应A~5A
                desc: '',       // 景区介绍
                desc_buy: '',   // 购买须知
                desc_welfare: '',// 景区福利
                appo: 1,        // 预约类型 1-平日 2-节假日
                g_type: [1],      // 交付方式 1-APP、短信、站内信 2-物流 3自提
                calendar_id: 0, // 日历ID 最小值为0
                image: [],      // 景区封面图 200个字符以内
                banner: [],     // 景区轮播图 json形式的图片地址列表，默认 []
                addr_s: '',     // 省市区，空格拼接 200个字符以内
                addr_i: '',     // 详细地址 200个字符以内
                time_s: '09:00',     // 开园时间 hh:mm[:ss] 格式 默认值: 09:00
                time_e: '18:00',     // 闭园时间 hh:mm[:ss] 格式 默认值: 18:00
                time: [new Date(2022,1,1,9,0), new Date(2022,1,1,18,0)],
                time_end: '17:00',   // 停止进场时间 hh:mm[:ss] 格式 默认值: 17:00
                sku_list: [     // 景区门票列表，默认 []
                    {
                        id: 0,          // 门票ID，若添加则此处为0或不传此值
                        is_delete: 0,   // 是否删除操作 0-否 1-是
                        name: '',       // 门票名称
                        price: '',      // 门票价格
                        u_times: '',    // 有效期 单位：天
                        u_type: 1,      // 使用类型 1-平日 2-节假日
                        tag_list: [],   // 选中标签列表，json形式列表
                        desc: '',       // 预定须知
                        desc_buy: ''    // 项目包含
                    }
                ],   
                image_detail: [],   // 封面图url
                banner_detail: [],  // 轮播图url
                sale: {
                    shop_num: 0,    // 累计售票数量
                    shop_price: 0,  // 累计售票金额
                    shop_comment: 0,// 累计评价数量
                    shop_start: 0   // 平均评价星级，0~5
                }
            },
            dateList: [],   // 预约日历列表
            typeList: [],   // 景区类型
            dialogImageUrl: '',
            dialogVisible: false,
            shop_opt: [],   // 店铺列表
        }
    },
    computed: {
        showForm () {
            let start = '一';
            let value = this.ruleForm.start;
            switch (value) {
                case 1:
                    start = '一';                    
                    break;
                case 2:
                    start = '二';                    
                    break;
                case 3:
                    start = '三';                    
                    break;
                case 4:
                    start = '四';                    
                    break;
                case 5:
                    start = '五';
                    break;
            
                default:
                    break;
            }
            let scenic_spot = '暂无';
            let type_index = this.typeList.findIndex(t => {
                return t.id == this.ruleForm.scenic_spot
            })
            if (type_index > -1) {
                scenic_spot = this.typeList[type_index].name
            }
            
            return {
                ...this.ruleForm,
                start,
                scenic_spot
            }
        }
    },
    methods: {
        // 查看全部评价
        lookAppraise () {
            let spu_id = this.$route.query.id,
                shop_id = this.$route.query.shop_id;
            if (!spu_id || !shop_id) {
                this.$message.wrning('信息已失效，请返回列表')
                return
            }
            this.$router.push({ path: '/home/baby-ticket-appraise', query: { spu_id, shop_id }})
        },
        handleChange1 (file, fileList) {},
        handleRemove1 (file, fileList) {},
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        initDateList () {
            getDateList()
                .then(res => {
                    if (res.data.code == 0) {
                        this.dateList = res.data.data.data
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg)
                })
        },
        getDetail () {
            let data = {
                id: this.$route.query.id,
                shop_id: this.$route.query.shop_id
            };
            if (!data.id || !data.shop_id) {
                this.$message.wrning('信息已失效，请返回列表')
                return
            }
            this.formLoading = true;
            getAreaDetail(data)
                .then(res => {
                    if (res.data.code == 0) {
                        let { data } = res.data;
                        this.ruleForm.id = data.id;
                        this.ruleForm.shop_id = data.shop_id;
                        this.ruleForm.shop_name = data.shop_name;
                        this.ruleForm.name = data.name;
                        this.ruleForm.start = data.start;
                        this.ruleForm.scenic_spot = data.scenic_spot;
                        // this.ruleForm.desc = data.desc;
                        this.ruleForm.desc = md.render(data.desc);
                        // this.ruleForm.desc_buy	 = data.desc_buy;
                        this.ruleForm.desc_buy = md.render(data.desc_buy);
                        // this.ruleForm.desc_welfare = data.desc_welfare;
                        this.ruleForm.desc_welfare = md.render(data.desc_welfare ? data.desc_welfare : '');
                        this.ruleForm.appo = data.appo;
                        this.ruleForm.g_type = data.g_type.split('');
                        this.ruleForm.calendar_id = data.calendar_id;
                        this.ruleForm.calendar_name = data.calendar_name;
                        // this.ruleForm.image = data.image.split().map(img => {return{url: img}});
                        // this.ruleForm.banner = JSON.parse(data.banner).map(img => {return{url: img}});
                        this.ruleForm.addr_s = data.addr_s;
                        this.ruleForm.addr_i = data.addr_i;
                        this.ruleForm.time_s = data.time_s;
                        this.ruleForm.time_e = data.time_e;
                        this.ruleForm.time_end = data.time_end;
                        this.ruleForm.sale = data.sale;
                        // this.ruleForm.sku_list = data.sku_list;
                        this.ruleForm.sku_list = data.sku_list.map(sku => {
                            return {
                                ...sku,
                                desc: md.render(sku.desc),
                                desc_buy: md.render(sku.desc_buy),
                            }
                        });
                        this.ruleForm.image_detail = data.image.split().map(img => {return{url: img}});
                        this.ruleForm.banner_detail = JSON.parse(data.banner).map(img => {return{url: img}});
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
                .finally(_ => {
                    this.formLoading = false;
                })
        },
        areaTypeList () {
            let params = {
                platform: 13
            }
            getAreaType(params)
                .then(res => {
                    if (res.data.code == 0) {
                        this.typeList = res.data.data.data;
                    } else {
                        this.$message.error(res.data.code);
                    }
                })
                .catch(err => {
                    this.$message.error(err.msg);
                })
        }
    },
    mounted () {},
    created () {
        if (getShopStorage()) {
            this.shop_opt = getShopStorage();
        }
        this.getDetail()
        this.initDateList();
        this.areaTypeList();
    }
}
</script>

<style lang="scss" scoped>
    #baby-ticket-form {
        min-width: 1260px;
        .title {
            box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
            width: 100%;
            background: #fff;
            padding: 15px 32px;
            display: flex;
            align-items: center;
            font-size: 18px;
            color: #000;
            font-weight: 600;
            .title-detail {
                margin-left: 5px;
                color: rgb(109, 109, 109);
                cursor: pointer;
            }
            p {
                font-size: 16px;
                color: #333;
                margin-left: 32px;

                span {
                    color: #e72f0d;
                    padding: 0 5px;
                }

                &:first-child {
                    font-size: 18px;
                    color: #333;
                    margin-left: 0;
                }

                &:nth-child(2) {
                    span {
                        color: #2448ff;
                    }
                }
            }
            .title-detail {
                cursor: pointer;
            }
        }
        .main {
            margin: 24px 24px 2px 24px;
            border-radius: 0;
            .subtitle {
                margin: 35px 0;
                display: flex;
                align-items: center;
                &:first-child {
                    margin-top: 0;
                }
                h4 {
                    padding-left: 20px;
                    line-height: 18px;
                    position: relative;
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                    &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 2px;
                    background: #2448ff;
                    }
                }
            }
        }
    }

    ::v-deep .el-card__body {
        padding-left: 60px;
        padding-top: 40px;
    }

    .mf {
        ::v-deep .el-upload--picture-card {
            display: none !important;
        }
    }

</style>